<!-- app页面——部门文档 -->
<template>
  <div class="deptDocH5">
    <van-nav-bar title="部门文档" left-arrow @click-left="toBack" />
    <div class="content">
      <!-- 下拉刷新列表 -->
      <van-pull-refresh v-model="refreshing" v-loading="loading" class="folderList" @refresh="onRefresh">
        <template v-for="item in authDocList">
          <div v-if="item.path !== '/depDoc-recycle'" :key="item.permissionKey" class="Doc" @click="intoDeptDoc(item)">
            <van-image class="Doc_logo" fit="contain" :src="docIcon" />
            <span class="Doc_name">{{ item.name }}</span>
            <van-icon name="ellipsis" class="moreIcon" @click.native.stop="moreOpen(item)" />
          </div>
          <div v-if="item.path === '/depDoc-recycle'" :key="item.permissionKey" class="Doc" @click="intoDeptRecycle">
            <van-image class="Doc_logo" fit="contain" :src="recycleBin" />
            <span class="Doc_name">{{ item.name }}</span>
            <van-icon name="arrow" class="rightIcon" />
          </div>
        </template>
        <div v-if="!authDocList.length" class="empty">暂无权限</div>
      </van-pull-refresh>
    </div>

    <!-- 部门文档更多弹框 -->
    <deptDocMore ref="deptDocMore" @toRefresh="toRefresh"></deptDocMore>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getMenuList } from "@/CommonDP/utils/tree";
import deptDocMore from "./deptDocMore.vue";

export default {
  components: { deptDocMore },
  data() {
    return {
      docIcon: require("../assets/doc.png"), // 图标
      recycleBin: require("../assets/personDocH5/recycleBin.png"),
      refreshing: false,
      loading: false
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      authRoutes: (state) => state.router.authRoutes // 当前用户权限
    }),
    // 用户有权限的文档目录
    authDocList() {
      const doc = this.authRoutes.find(({ permissionKey }) => permissionKey === "doc");
      const docList = doc ? this.menuList([doc]) : []; // 知识菜单列表
      const deptDoc = docList.find(({ permissionKey }) => permissionKey === "enterpriseDeptDoc");
      const deptDocList = deptDoc ? deptDoc.sub : []; // 企业部门菜单列表
      return deptDocList;
    }
  },
  mounted() {},
  methods: {
    // 返回上一页
    toBack() {
      this.$router.go(-1);
    },
    // 对象转菜单列表
    menuList(array) {
      const list = getMenuList(array) || [];
      if (list.length > 0) {
        if (list[0].sub && list[0].sub.length > 0) {
          list[0].sub = list[0].sub.filter(({ resourceType }) => resourceType === 0);
          return list[0].sub;
        }
      }
      return [];
    },

    // 刷新列表
    async toRefresh() {
      this.loading = true;
      try {
        await this.$store.dispatch("setRouterNav", []);
        await this.$store.commit("saveFlatRoutes", []);
        // await this.$store.dispatch("queryEnterpriseDept");
        this.$store.dispatch("GetModuleList", this.enterpriseId);
      } finally {
        this.loading = false;
      }
    },
    // 下拉刷新
    async onRefresh() {
      try {
        await this.toRefresh();
      } finally {
        this.refreshing = false;
      }
    },

    // 进入我的文档
    intoDeptDoc(item) {
      this.$router.push({ path: "/deptDocH5/deptInfoH5", query: { deptItem: item }});
    },
    // 进入部门回收站
    intoDeptRecycle() {
      this.$router.push("/deptDocH5/deptRecycleH5");
    },
    // 点击... 打开更多
    moreOpen(item) {
      this.$refs.deptDocMore.setFolderPrivi(item);
    }
  }
};
</script>

<style lang="scss" scoped>
.deptDocH5 {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #f5f6fa;

  .content {
    width: 100%;
    height: calc(100% - 56px);
    margin-top: 10px;
  }
}

.folderList {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  .empty {
    width: 100%;
    height: calc(100% - 66px);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--info-color)9;
    font-size: 16px;
  }
}

.Doc {
  width: 100vw;
  height: 70px;
  padding: 0 3vw;
  box-sizing: border-box;
  background-color: #ffffff;
  border-bottom: 1px solid #e5e8f1;
  display: flex;
  align-items: center;

  .Doc_logo {
    width: 42px;
    height: 42px;
    padding: 5px;
    margin-bottom: 2px;
  }

  .Doc_name {
    width: calc(100% - 65px);
    padding-left: 5px;
    line-height: 40px;
    font-size: 16px;
  }

  .moreIcon {
    padding: 6px;
    font-size: 18px;
  }
  .rightIcon {
    font-size: 14px;
    color: #6f6f6f;
  }
}

::-webkit-scrollbar {
  display: none;
}
</style>
